module.exports = __webpack_public_path__ + "static/img/homePage1.50a05c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homePage1.jpg
// module id = I1Hm
// module chunks = 1